"use client";

import { Input, InputProps } from "@/components/Input";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { BuilderBlockProps } from "@/types/builder/BuilderBlockProps";
import { FC, useEffect } from "react";
import { CallbackReturnType } from "@/types";
import { getHrefFromCustomUrlPlugin } from "@/helpers";

type SearchInputBlockProps = Omit<
  Extract<InputProps, { type: "search" }>,
  "onChange"
> & {
  onChange?: (event: string) => CallbackReturnType;
  onInitialize?: () => CallbackReturnType;
} & Pick<BuilderProps, "builderContext"> &
  BuilderBlockProps;

export const SearchInputBlock: FC<SearchInputBlockProps> = ({
  children: _,
  attributes,
  builderContext,
  onInitialize,
  ...props
}) => {
  useEffect(() => {
    if (onInitialize) {
      onInitialize();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mappedSuggestions = props.suggestions?.map((suggestion) =>
    suggestion.type === "search"
      ? suggestion
      : {
          type: "link" as const,
          title: suggestion.title ?? "",
          href: getHrefFromCustomUrlPlugin(suggestion.href ?? "/"),
          dld: suggestion.dld ?? "",
          dlt: suggestion.dlt ?? "",
        },
  );
  return (
    <Input
      {...attributes}
      {...props}
      type="search"
      suggestions={mappedSuggestions}
    />
  );
};
